enum LoadingButton {
  BeforeLoading,
  Loading,
  DoneLoading,
}

export default LoadingButton;
